import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { BisualSetting } from '../models/bisual-setting.model';
import { EmployeeService } from './employee.service';
import { User } from '../models/user.model';

@Injectable({
  providedIn: 'root',
})
export class BisualSettingService {
  private bisualSettingSubject: BehaviorSubject<{ [key: string]: BisualSetting }> = new BehaviorSubject(null as any);
  public bisualSettingObservable: Observable<{ [key: string]: BisualSetting }> = this.bisualSettingSubject.asObservable();

  private readonly api: ApiService = inject(ApiService);
  private readonly employee: EmployeeService = inject(EmployeeService);

  init(user: User) {
    this.fetch(user);
  }

  getSettings() {
    return this.bisualSettingSubject.value;
  }

  get(key: string) {
    return this.bisualSettingSubject.value[key];
  }

  private fetch(user: User) {
    this.api.getBisualSettingsByKeys(['force-employees-to-use-desktop-app', 'working-time-edit-delete-window-hours']).subscribe(data => {
      const res: { [key: string]: BisualSetting } = {};

      data.forEach(setting => {
        res[setting.key] = setting;
      });

      this.bisualSettingSubject.next(res);
      if (user.role.slug === 'worker') {
        this.employee.init(user, this.get('force-employees-to-use-desktop-app')?.value === 'true');
      }
    });
  }
}
